import { render, staticRenderFns } from "./CallBtn.vue?vue&type=template&id=2840987a&"
import script from "./CallBtn.vue?vue&type=script&lang=js&"
export * from "./CallBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports